import { BASIC_COURSE_SOURCE_ALIASES } from "./basicCourseSourceAliases";
import entries from "./basicCourseMetadata.generated.json";
import { groupBasicCourseTypes, getBasicCourseGroupTypes } from "./basicCourseTaskGroups";

const MONTHS = { marzec: 3, maj: 5, czerwiec: 6, sierpien: 8, grudzien: 12 };
export function getBasicSheetDate(sheetId) {
  const [, , year, month] = String(sheetId).split("-");
  return Number(year) * 100 + (MONTHS[month] || 0);
}

const catalog = new Map(entries.map(entry => [entry.type, entry]));
export const getBasicCourseCatalog = () => catalog;

export function getBasicCourseGroupSources(type) {
  return getBasicCourseGroupTypes(BASIC_COURSE_SOURCE_ALIASES[type] || type)
    .flatMap(member => (catalog.get(member)?.sources || []).map(source => ({ ...source, type: member })))
    .sort((a, b) => b.dateKey - a.dateKey
      || a.taskNo.localeCompare(b.taskNo, "pl", { numeric: true }));
}

export function orderBasicCourseTypes(types) {
  return groupBasicCourseTypes(types).sort((a, b) => {
    const left = getBasicCourseGroupSources(a)[0];
    const right = getBasicCourseGroupSources(b)[0];
    return (right?.dateKey || 0) - (left?.dateKey || 0)
      || (left?.taskNo || "").localeCompare(right?.taskNo || "", "pl", { numeric: true });
  });
}
